export enum ActionTypes {
  CLOSE_ALERT_SNACKBAR = 'AlertSnackbar/close',
  CLOSE_IN_APP_DIALOG = 'InAppDialog/close',
  NAVIGATE_TO = 'navigateTo',
  OPEN_ALERT_SNACKBAR = 'AlertSnackbar/open',
  OPEN_IN_APP_DIALOG = 'InAppDialog/open',
  OPEN_NOTIFICATIONS_DRAWER = 'NotificationsDrawer/open',
  TURN_PARTNER_ON = 'turnPartnerOn',
}
